"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _EventGroups = _interopRequireDefault(require("../constants/EventGroups"));

var FIREALARM_PREOADED_EVENTS_KEY = '_preLoadEvents';

var Events =
/*#__PURE__*/
function () {
  function Events() {
    var _this = this;

    (0, _classCallCheck2.default)(this, Events);
    this.events = {};
    this.eventMarkers = {};

    _EventGroups.default.keys().forEach(function (key) {
      var group = _EventGroups.default[key];
      _this.events[group] = [];
    });
  }

  (0, _createClass2.default)(Events, [{
    key: "addEvent",
    value: function addEvent(group, callback) {
      this.events[group] = this.events[group] || [];
      this.events[group].push(callback);
    }
  }, {
    key: "addEventMarker",
    value: function addEventMarker(marker, data) {
      this.eventMarkers[marker] = this.eventMarkers[marker] || [];
      this.eventMarkers[marker].push(data);
    }
  }, {
    key: "extractPreloadEvents",
    value: function extractPreloadEvents(data) {
      var _this2 = this;

      var preloadEvents = data && data[FIREALARM_PREOADED_EVENTS_KEY] ? data[FIREALARM_PREOADED_EVENTS_KEY] : {};

      _EventGroups.default.keys().forEach(function (key) {
        var group = _EventGroups.default[key];

        if (preloadEvents[group] && Array.isArray(preloadEvents[group])) {
          preloadEvents[group].map(function (callback) {
            _this2.addEvent(group, callback);
          });
        }
      });
    }
  }, {
    key: "runEvents",
    value: function runEvents(eventGroup, data) {
      var eventData = {
        eventGroup: eventGroup,
        data: data
      };

      if (this.events[eventGroup]) {
        switch (eventGroup) {
          case _EventGroups.default.eventGroups.CREATE_ALARM:
            {
              this.events[eventGroup].map(function (alarmData) {
                data.addAlarm(alarmData);
              });
              break;
            }

          default:
            {
              this.events[eventGroup].map(function (callback) {
                callback(eventData);
              });
            }
        }
      }

      this.addEventMarker(eventGroup, eventData);
    }
  }]);
  return Events;
}();

var _default = Events;
exports.default = _default;
module.exports = exports.default;